/**
 * Hampers Galore Custom Deferred Optimization Script (assets/hg-custom.js)
 * Consolidates non-critical UI scripts to minimize inline HTML script overhead and achieve sub-100ms INP.
 */

(function() {
  'use strict';

  /* ─────────────────────────────────────────────────────
     1. Mobile Navigation Drawer Tab Lazy-Unwrapping
  ───────────────────────────────────────────────────── */
  function unwrapTab(tabItem) {
    if (!tabItem) return;
    var tmpl = tabItem.querySelector('template');
    if (tmpl && tmpl.content) {
      tabItem.appendChild(tmpl.content.cloneNode(true));
      tmpl.remove();
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('hdt-tab[aria-controls="tab-mobile-custom"] button');
    if (!btn) return;
    var tabGroup = document.getElementById('tab-mobile-custom');
    if (!tabGroup) return;
    var buttons = Array.from(btn.closest('hdt-tab').querySelectorAll('button'));
    var idx = buttons.indexOf(btn);
    if (idx !== -1) {
      var tabItems = tabGroup.querySelectorAll(':scope > .hdt-tab-item');
      if (tabItems[idx]) {
        unwrapTab(tabItems[idx]);
      }
    }
  }, { capture: true });

  /* ─────────────────────────────────────────────────────
     2. Mini-Cart & Cart Drawer Complementary ATC / Sync
  ───────────────────────────────────────────────────── */
  function formatCartMoney(cents) {
    try {
      var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
        ? window.themeHDN.settings.moneyFormat : '${{amount}}';
      return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
    } catch(e) { return '$' + (cents / 100).toFixed(2); }
  }

  function updateBadge(n, totalFormatted) {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart) hdtCart.setAttribute('data-count', n);
    document.querySelectorAll('hdt-cart-count').forEach(function(el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
      if (n > 0) el.removeAttribute('hidden');
    });
    if (totalFormatted) {
      document.querySelectorAll('hdt-cart-total').forEach(function(el) { el.textContent = totalFormatted; });
    }
    ['.hdt-mini-cart__count','.hdt-header__cart-count','[data-cart-count]',
     '[data-header-cart-count]','#cart-icon-bubble','.cart-count-bubble span',
     '.t4s-cart-count','.t4s-cart-icon__count'].forEach(function(s) {
      document.querySelectorAll(s).forEach(function(el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
      });
    });
  }

  function openHDTCart() {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
    var triggers = ['[aria-controls="CartDrawer"]','[data-cart-drawer-trigger]',
      '.hdt-header__cart','.hdt-header__icon--cart','button[data-cart]',
      'a[href="/cart"].hdt-header__icon','.t4s-site-nav__cart > a',
      '[data-t4s-open-quickcart]','[data-open-quickcart]','.t4s-cart-icon a'];
    for (var i = 0; i < triggers.length; i++) {
      var el = document.querySelector(triggers[i]);
      if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
    }
    document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateBadge(cart.item_count, formatCartMoney(cart.total_price));
        var hdtCart = document.querySelector('hdt-cart-drawer');
        if (!hdtCart) { openHDTCart(); return; }
        if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); openHDTCart(); return; }
        if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); openHDTCart(); return; }
        var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
        fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var html = data[sectionId];
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('cart-items-component');
              var live  = document.querySelector('cart-items-component');
              if (fresh && live) live.replaceWith(fresh);
            }
            openHDTCart();
          }).catch(function() { openHDTCart(); });
      }).catch(function() { openHDTCart(); });
  }

  var _compInFlight = {};
  function doCompATC(variantId, card) {
    if (_compInFlight[variantId]) return;
    _compInFlight[variantId] = true;

    var btn         = card ? card.querySelector('.hdt-complementary-atc-btn') : null;
    var spinner     = btn  ? btn.querySelector('.hdt-loading__spinner') : null;
    var icon        = btn  ? btn.querySelector('.hdt-complementary-atc-icon') : null;
    var iconSuccess = btn  ? btn.querySelector('.hdt-complementary-atc-icon--success') : null;

    if (btn)     { btn.disabled = true; btn.setAttribute('data-loading', 'true'); }
    if (spinner) spinner.removeAttribute('hidden');
    if (icon)    icon.setAttribute('hidden', '');

    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
    .then(function(result) {
      delete _compInFlight[variantId];
      if (spinner) spinner.setAttribute('hidden', '');

      if (result.ok) {
        if (iconSuccess) iconSuccess.removeAttribute('hidden');
        refreshCart();
        setTimeout(function() {
          var slide = card ? (card.closest('.hdt-slider__slide') || card) : null;
          if (slide) slide.remove();
        }, 800);
      } else {
        if (btn)         { btn.disabled = false; btn.removeAttribute('data-loading'); }
        if (icon)        icon.removeAttribute('hidden');
        if (iconSuccess) iconSuccess.setAttribute('hidden', '');
        console.warn('[Complementary ATC] Failed:', (result.data.description || result.data.message));
      }
    })
    .catch(function(err) {
      delete _compInFlight[variantId];
      if (spinner)     spinner.setAttribute('hidden', '');
      if (btn)         { btn.disabled = false; btn.removeAttribute('data-loading'); }
      if (icon)        icon.removeAttribute('hidden');
      if (iconSuccess) iconSuccess.setAttribute('hidden', '');
      console.error('[Complementary ATC] Network error:', err);
    });
  }

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-complementary-atc]');
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId   = el.getAttribute('data-variant-id');
    var isAvailable = el.getAttribute('data-available');
    if (!variantId || isAvailable === 'false') return;

    var card = el.closest('.hdt-minicart-recommendations__item');
    if (!card) return;

    var btn = card.querySelector('.hdt-complementary-atc-btn');
    if (btn && btn.getAttribute('data-loading')) return;

    doCompATC(variantId, card);
  }, true);

  /* ─────────────────────────────────────────────────────
     3. Urgency Countdown Timers & Coupon Copy
  ───────────────────────────────────────────────────── */
  function initUrgencyTimers() {
    document.querySelectorAll('.tb-offer-timer, .hg-offer-timer').forEach(function(wrap) {
      if (wrap._hgTimerInit) return;
      wrap._hgTimerInit = true;
      var duration = parseInt(wrap.dataset.duration) || 0;
      var remaining = duration;

      function updateTimer() {
        if (remaining <= 0) remaining = duration;
        var days = Math.floor(remaining / 86400);
        var hours = Math.floor((remaining % 86400) / 3600);
        var minutes = Math.floor((remaining % 3600) / 60);
        var seconds = remaining % 60;

        var dEl = wrap.querySelector('[data-days]');
        var hEl = wrap.querySelector('[data-hours]');
        var mEl = wrap.querySelector('[data-minutes]');
        var sEl = wrap.querySelector('[data-seconds]');

        var dStr = String(days).padStart(2, '0');
        var hStr = String(hours).padStart(2, '0');
        var mStr = String(minutes).padStart(2, '0');
        var sStr = String(seconds).padStart(2, '0');

        if (dEl && dEl.textContent !== dStr) dEl.textContent = dStr;
        if (hEl && hEl.textContent !== hStr) hEl.textContent = hStr;
        if (mEl && mEl.textContent !== mStr) mEl.textContent = mStr;
        if (sEl && sEl.textContent !== sStr) sEl.textContent = sStr;
        remaining--;
      }
      updateTimer();
      setInterval(updateTimer, 1000);
    });
  }

  document.addEventListener('click', function(e) {
    var offer = e.target.closest('.tb-offer, .hg-offer');
    if (!offer) return;
    var code = offer.dataset.code;
    if (code && navigator.clipboard) {
      navigator.clipboard.writeText(code);
      offer.classList.add('copied');
      setTimeout(function() { offer.classList.remove('copied'); }, 1200);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUrgencyTimers);
  } else {
    initUrgencyTimers();
  }

  // Section 4 (Product Card ATC delegate) is unified at the bottom under INP FIX #1 v3 with scheduler.yield()




  

})();


// Sticky add to cart: keep sticky + main product forms in sync (qty, variant).
function getStickyProductForms() {
  const stickyAtc = document.querySelector('hdt-sticky-btn-atc');
  const stickyForm = document.querySelector('.hdt-sticky-atc__form');
  if (!stickyAtc || !stickyForm) return null;

  const mainFormId = stickyAtc.getAttribute('form');
  const mainForm = mainFormId ? document.getElementById(mainFormId) : document.querySelector('.hdt-main-product-form');
  if (!mainForm) return null;

  return { stickyForm, mainForm };
}

function syncProductFormField(stickyForm, mainForm, fieldName) {
  const stickyField = stickyForm.querySelector(`[name="${fieldName}"]`);
  const mainField = mainForm.querySelector(`[name="${fieldName}"]`);
  if (!stickyField || !mainField) return;

  mainField.value = stickyField.value;
  if (mainField.disabled) mainField.disabled = false;
}

function syncMainProductFormFromSticky() {
  const forms = getStickyProductForms();
  if (!forms) return;
  syncProductFormField(forms.stickyForm, forms.mainForm, 'quantity');
  syncProductFormField(forms.stickyForm, forms.mainForm, 'id');
}

function syncStickyProductFormFromMain() {
  const forms = getStickyProductForms();
  if (!forms) return;
  syncProductFormField(forms.mainForm, forms.stickyForm, 'quantity');
  syncProductFormField(forms.mainForm, forms.stickyForm, 'id');
}

function clampStickyQuantityInput(input) {
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || parseInt(input.dataset.max, 10) || 9999;
  const step = parseInt(input.step, 10) || 1;
  let value = parseInt(input.value, 10) || min;
  value = Math.max(min, Math.min(max, value));
  if (step > 1) {
    value = min + Math.round((value - min) / step) * step;
    value = Math.max(min, Math.min(max, value));
  }
  input.value = value;
  const minusBtn = input.closest('hdt-quantity-wrapp')?.querySelector('.hdt-quantity__button[name="minus"]');
  const plusBtn = input.closest('hdt-quantity-wrapp')?.querySelector('.hdt-quantity__button[name="plus"]');
  if (minusBtn) minusBtn.classList.toggle('disabled', value <= min);
  if (plusBtn) plusBtn.classList.toggle('disabled', value >= max);
}

function initStickyProductQuantity() {
  const forms = getStickyProductForms();
  if (!forms || forms.stickyForm.dataset.tbQtySync === 'true') return;
  forms.stickyForm.dataset.tbQtySync = 'true';

  const stickyQty = forms.stickyForm.querySelector('input[name="quantity"]');
  const mainQty = forms.mainForm.querySelector('input[name="quantity"]');

  if (stickyQty) {
    clampStickyQuantityInput(stickyQty);
    stickyQty.addEventListener('change', function () {
      clampStickyQuantityInput(stickyQty);
      syncProductFormField(forms.stickyForm, forms.mainForm, 'quantity');
    });
  }

  if (mainQty) {
    mainQty.addEventListener('change', function () {
      syncProductFormField(forms.mainForm, forms.stickyForm, 'quantity');
      if (stickyQty) clampStickyQuantityInput(stickyQty);
    });
  }

  const onVariantChange = function () {
    syncStickyProductFormFromMain();
    if (stickyQty) clampStickyQuantityInput(stickyQty);
  };

  forms.mainForm.addEventListener('variant:change', onVariantChange);
  forms.stickyForm.addEventListener('variant:change', onVariantChange);
}

function handleStickyQuantityButtonClick(event) {
  const button = event.target.closest('.hdt-sticky-atc__qty-selector .hdt-quantity__button');
  if (!button) return;

  const forms = getStickyProductForms();
  if (!forms) return;

  const input = forms.stickyForm.querySelector('input[name="quantity"]');
  if (!input) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const step = parseInt(input.step, 10) || 1;
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || parseInt(input.dataset.max, 10) || 9999;
  let value = parseInt(input.value, 10) || min;

  if (button.name === 'plus') {
    value = Math.min(value + step, max);
  } else if (button.name === 'minus') {
    value = Math.max(value - step, min);
  }

  input.value = value;
  clampStickyQuantityInput(input);
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function initStickyAtcInteractions() {
  initStickyProductQuantity();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAtcInteractions);
} else {
  initStickyAtcInteractions();
}
document.addEventListener('shopify:section:load', initStickyAtcInteractions);

document.addEventListener('click', handleStickyQuantityButtonClick, true);

// Sticky add to cart uses the main form handler after syncing sticky values.
document.addEventListener('click', function (e) {
  const stickyBtn = e.target.closest('.hdt-sticky-atc__submit');
  if (stickyBtn) {
    e.preventDefault();
    e.stopPropagation();

    syncMainProductFormFromSticky();

    const spinnerOverlay = document.createElement('span');
    spinnerOverlay.style.cssText = `
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: inherit;
      border-radius: inherit;
      pointer-events: none;
    `;
    spinnerOverlay.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"
        style="animation: hdtSpin 0.8s linear infinite;">
        <circle fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"
          stroke-dasharray="80, 200" stroke-linecap="round"/>
      </svg>
    `;

    stickyBtn.style.pointerEvents = 'none';
    stickyBtn.appendChild(spinnerOverlay);

    setTimeout(function () {
      spinnerOverlay.remove();
      stickyBtn.style.pointerEvents = '';
    }, 3000);

    const yieldFn = (typeof scheduler !== 'undefined' && typeof scheduler.yield === 'function') ? scheduler.yield() : Promise.resolve();
    yieldFn.then(function () {
      const mainBtn = document.querySelector('.hdt-product-form__submit');
      if (mainBtn) mainBtn.click();
    });
  }
}, true);





// INP FIX #1 v3 - Product Card Add to Cart (gba-card-atc)
// TARGET: < 180ms INP on mobile, < 100ms on desktop
//
// HOW SUB-180ms INP IS ACHIEVED:
//
//   INP = time from user interaction (click/tap) to next browser paint.
//
//   STEP 1 [SYNCHRONOUS ~1ms]:
//     btn.disabled = true  - only DOM work in the click handler.
//     CSS :disabled handles all visuals (no class changes, no text mutations).
//
//   STEP 2 [YIELD - lets browser paint]:
//     scheduler.yield() (Chrome 115+) or Promise.resolve() fallback.
//     Browser commits a paint frame showing the :disabled button.
//     INP is measured to THIS paint. Done. ~5-20ms desktop, ~20-50ms mobile.
//
//   STEP 3 [ASYNC - after paint]:
//     fetch('/cart/add.js') runs. Never blocks the main thread.
//     Success: .ok CSS class + Added! text + refreshCart().
//     These run ~200-400ms after click - well outside the INP window.
//
//   MOBILE EXTRA: touch-action: manipulation on the button (hg-custom.css)
//     eliminates the 300ms double-tap-zoom delay on iOS Safari.
//     Without it, mobile INP cannot be < 300ms regardless of JS speed.

(function () {
  'use strict';

  // Yield helper: Chrome 115+ native, or Promise.resolve() micro-task fallback
  function _yield() {
    if (typeof scheduler !== 'undefined' && typeof scheduler.yield === 'function') {
      return scheduler.yield();
    }
    return Promise.resolve();
  }

  // Cart badge update - mirrors gift-finder updateBadge exactly
  function _cardAtcUpdateBadge(n, totalFormatted) {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart) hdtCart.setAttribute('data-count', n);
    document.querySelectorAll('hdt-cart-count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
      else { el.style.display = 'none'; }
    });
    if (totalFormatted) {
      document.querySelectorAll('hdt-cart-total').forEach(function (el) { el.textContent = totalFormatted; });
    }
    var sels = ['.hdt-mini-cart__count', '.hdt-header__cart-count', '[data-cart-count]',
      '[data-header-cart-count]', '#cart-icon-bubble', '.cart-count-bubble span'];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.textContent = n; });
    });
  }

  // Money formatter - mirrors gift-finder formatCartMoney exactly
  function _cardAtcFormatMoney(cents) {
    try {
      var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
        ? window.themeHDN.settings.moneyFormat : '${{amount}}';
      return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // Open cart drawer - mirrors gift-finder openHDTCart exactly
  function _cardAtcOpenCart() {
    var hdtCart = document.querySelector('hdt-cart-drawer');
    if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
    var trigSels = ['[aria-controls="CartDrawer"]', '[data-cart-drawer-trigger]',
      '.hdt-header__cart', '.hdt-header__icon--cart', 'button[data-cart]',
      'a[href="/cart"].hdt-header__icon'];
    for (var i = 0; i < trigSels.length; i++) {
      var el = document.querySelector(trigSels[i]);
      if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
    }
    document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
  }

  // Refresh cart drawer + badge - mirrors gift-finder refreshCart exactly
  function _cardAtcRefreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _cardAtcUpdateBadge(cart.item_count, _cardAtcFormatMoney(cart.total_price));
        var hdtCart = document.querySelector('hdt-cart-drawer');
        if (!hdtCart) { _cardAtcOpenCart(); return; }
        if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); _cardAtcOpenCart(); return; }
        if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); _cardAtcOpenCart(); return; }
        var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
        fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[sectionId] || null;
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('cart-items-component');
              var live = document.querySelector('cart-items-component');
              if (fresh && live) live.replaceWith(fresh);
            }
            _cardAtcOpenCart();
          })
          .catch(function () { _cardAtcOpenCart(); });
      })
      .catch(function () { _cardAtcOpenCart(); });
  }

  // Single delegated click listener for ALL product card ATC buttons (.gba-card-atc and .gba-atc)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gba-card-atc[data-vid], .gba-atc[data-vid]');
    if (!btn || btn.disabled) return;

    var vid = btn.dataset.vid;
    var qty = parseInt(btn.dataset.qty || 1, 10);
    if (!vid) return;

    // DOM READ (synchronous) -- querySelector is a pure read, no reflow/paint.
    // Cache here so all promise callbacks can reference it without re-querying.
    var txtSpan = btn.querySelector('.hdt-truncate') || btn.querySelector('.gba-atc-txt');
    var origText = txtSpan ? (txtSpan.dataset.originalText || txtSpan.textContent) : '';
    if (txtSpan && origText) txtSpan.dataset.originalText = origText;

    // STEP 1: Single synchronous DOM WRITE — triggers :disabled repaint.
    // CSS :disabled { opacity:0.65; cursor:not-allowed } handles visual feedback.
    // INP = click to this paint. No extra class, no text change here.
    btn.disabled = true;

    // STEP 2: Yield — browser commits the :disabled paint frame.
    // INP is measured to THAT paint (~5-20ms desktop, ~20-50ms mobile).
    // Everything after this point is outside the INP measurement window.
    _yield()
      .then(function () {
        // "Adding..." runs AFTER the INP paint frame — user sees it in the very
        // next frame (~16ms after click) but does NOT count toward INP score.
        if (txtSpan) txtSpan.textContent = 'Adding\u2026';

        // STEP 3: Fetch — fully async, never blocks main thread.
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        // Success -- ~200-400ms after click (well outside INP window).
        btn.classList.add('ok');
        if (txtSpan) txtSpan.textContent = '\u2713 Added!';
        _cardAtcRefreshCart();
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('ok');
          if (txtSpan) txtSpan.textContent = origText;
        }, 2200);
      })
      .catch(function (err) {
        // Error -- re-enable and restore original label.
        btn.disabled = false;
        if (txtSpan) txtSpan.textContent = origText;
        var msg = (err && err.description) ? err.description
          : (err && err.message) ? err.message
            : 'Could not add item. Please try again.';
        alert(msg);
      });

  });

}());
// END INP FIX #1 v3


// -------------------------------------------------------------
// Mobile 2x2 Facet Dropdowns UX (Devices <= 1024px)
// Handles: Exclusive opening, Click-outside dismissal,
// 'Done' / Close button handling, and Price submit dismissal.
// -------------------------------------------------------------
(function initMobileFacetDropdowns() {
  document.addEventListener('click', function(e) {
    if (!document.querySelector('.hg-facet-dropdown')) return;

    // 1. Close button or Done button
    const closeBtn = e.target.closest('[data-close-dropdown]');
    if (closeBtn) {
      const details = closeBtn.closest('.hg-facet-dropdown');
      if (details) {
        e.preventDefault();
        details.removeAttribute('open');
      }
      return;
    }

    // 2. Price apply button submit: close price dropdown so results are cleanly displayed
    const priceApplyBtn = e.target.closest('.hg-price-range-wrap wrapp-hdt-btn-submit-filter');
    if (priceApplyBtn) {
      const details = priceApplyBtn.closest('.hg-facet-dropdown');
      if (details) {
        setTimeout(function() {
          details.removeAttribute('open');
        }, 50);
      }
      return;
    }

    // 3. Exclusive accordion behavior when opening another dropdown
    const summary = e.target.closest('.hg-facet-dropdown > summary');
    if (summary) {
      const parentDetails = summary.parentElement;
      document.querySelectorAll('.hg-facet-dropdown[open]').forEach(function(details) {
        if (details !== parentDetails) {
          details.removeAttribute('open');
        }
      });
      return;
    }

    // 4. Click outside open dropdowns: dismiss them
    const openDropdown = document.querySelector('.hg-facet-dropdown[open]');
    if (openDropdown && !openDropdown.contains(e.target)) {
      openDropdown.removeAttribute('open');
    }
  }, true);

  // Close on Escape key
    // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hg-facet-dropdown[open]').forEach(function(details) {
        details.removeAttribute('open');
      });
    }
  });
})();






/************************************************************************************ */

// custom cart cyo 
// Function to disable CYO product links in both cart drawer and cart page
// Function to remove href attributes from CYO products
// custom cart cyo
(function () {

  function isCYOorBulk(item) {
    // New theme selectors
    const titleLink = item.querySelector('.hdt-mini-cart__title, .hdt-page-cart__title');
    const hasBoxProperty = item.querySelector('.hdt-product-details__item-label span');

    if (titleLink) {
      const titleText = titleLink.textContent.trim();
      if (titleText.startsWith('CYO') || titleText.includes('Bulk')) return true;
    }
    if (hasBoxProperty && hasBoxProperty.textContent.trim() === 'Box:') return true;

    return false;
  }

  function disableLinks(item) {
    // Disable title link
    const titleLink = item.querySelector('.hdt-mini-cart__title, .hdt-page-cart__title');
    if (titleLink) {
      titleLink.removeAttribute('href');
      titleLink.style.cursor = 'default';
      titleLink.style.textDecoration = 'none';
      titleLink.style.pointerEvents = 'none';
    }

    // Disable image link
    const imageLink = item.querySelector('.hdt-mini-cart__img, .hdt-page-cart__img');
    if (imageLink) {
      imageLink.removeAttribute('href');
      imageLink.style.cursor = 'default';
      imageLink.style.pointerEvents = 'none';
    }
  }

  function removeCYOProductHrefs() {
    // New theme cart item selectors
    const cartItems = document.querySelectorAll('hdt-line-item');
    cartItems.forEach(item => {
      if (isCYOorBulk(item)) {
        disableLinks(item);
      }
    });
  }

  // ✅ Single bulletproof observer on document.body
  new MutationObserver(function () {
    removeCYOProductHrefs();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  // ✅ Block ALL clicks as backup (capturing phase)
  document.addEventListener('click', function (e) {
    const cartItem = e.target.closest('hdt-line-item');
    if (cartItem && isCYOorBulk(cartItem)) {
      // Only block clicks on title/image links, not remove/quantity buttons
      const isTitle = e.target.closest('.hdt-mini-cart__title, .hdt-page-cart__title');
      const isImage = e.target.closest('.hdt-mini-cart__img, .hdt-page-cart__img');
      if (isTitle || isImage) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }
  }, true);

  // ✅ Initial runs
  document.addEventListener('DOMContentLoaded', removeCYOProductHrefs);
  setTimeout(removeCYOProductHrefs, 300);
  setTimeout(removeCYOProductHrefs, 800);
  setTimeout(removeCYOProductHrefs, 1500);

  // ✅ Cart events
  document.addEventListener('cart:updated', removeCYOProductHrefs);
  document.addEventListener('cart:refresh', removeCYOProductHrefs);

})();
// custom cart cyo -end  
 //cyo bundle creator easify app js

(function () {
  const STEP = 10;

  // ─── Selectors (stable hooks, not the random module classes) ────────────────
  const GRID_SELECTOR   = '.cyo-product-grid-wapper';
  const CARD_SELECTOR   = '[data-product-id][data-variant-ids]';
  const TITLE_SELECTOR  = '.PRODUCT_CARD_TITLE_TS';
  const ACCORDION_SELECTOR = '[class*="accordionElement-module__accordionContentItem"]';

  const EXCLUDED_WORDS = ['cyo', 'voucher', 'egift', 'create your own'];

  const gridsState = new Map();
  let isPaused = false;

  function getTitleText(product) {
    const titleEl = product.querySelector(TITLE_SELECTOR);
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function isTitleLoaded(product) {
    return getTitleText(product) !== '';
  }

  function isExcluded(product) {
    if (product.getAttribute('data-excluded') === 'true') return true;

    // Hidden by something else (not by this script)
    const inlineDisplay = product.style.display;
    if (!inlineDisplay) {
      if (window.getComputedStyle(product).display === 'none') return true;
    }

    const title = getTitleText(product).toLowerCase();
    if (!title) return false;
    return EXCLUDED_WORDS.some(word => title.includes(word));
  }

  function getAllProducts(gridWrapper) {
    return Array.from(gridWrapper.querySelectorAll(CARD_SELECTOR));
  }

  function getEligibleProducts(gridWrapper) {
    return getAllProducts(gridWrapper).filter(
      p => p.getAttribute('data-excluded') !== 'true'
    );
  }

  function hideExcludedProducts(gridWrapper) {
    getAllProducts(gridWrapper).forEach(product => {
      if (product.getAttribute('data-excluded') === 'true') return;
      if (isExcluded(product)) {
        product.style.display = 'none';
        product.setAttribute('data-excluded', 'true');
      }
    });
  }

  function applyVisibility(gridWrapper, visibleItems) {
    getEligibleProducts(gridWrapper).forEach((product, index) => {
      product.style.display = index < visibleItems ? '' : 'none';
    });
  }

  function updateButtonVisibility(gridWrapper, state) {
    if (!state.btnElement) return;
    const eligible = getEligibleProducts(gridWrapper);

    // Show button only if there are still hidden products
    state.btnElement.style.display =
      eligible.length > state.visibleItems ? 'block' : 'none';
  }

  function waitForTitles(gridWrapper, callback) {
    const maxWait = 10000;
    const interval = 100;
    let elapsed = 0;

    const check = setInterval(() => {
      const allProducts = getAllProducts(gridWrapper);
      const allTitlesLoaded =
        allProducts.length > 0 && allProducts.every(isTitleLoaded);

      elapsed += interval;
      if (allTitlesLoaded || elapsed >= maxWait) {
        clearInterval(check);
        callback();
      }
    }, interval);
  }

  function createLoadMoreButton(gridWrapper, state) {
    const btnWrapper = document.createElement('div');
    btnWrapper.className = 'cyo-load-more-wrapper';
    btnWrapper.style.cssText =
      'text-align:center; margin: 30px 0; width:100%; clear:both;';

    btnWrapper.innerHTML = `
      <button type="button" class="cyo-load-more-btn" style="cursor:pointer; padding: 12px 35px; z-index:9 !important; background:#000; color:#fff; border:none; border-radius:4px; font-weight:bold; font-size:16px;">
        Load More Products
      </button>`;

    const btn = btnWrapper.querySelector('button');

    btn.addEventListener('click', e => {
      e.preventDefault();
      if (btn.disabled) return;

      btn.disabled = true;
      isPaused = true;

      hideExcludedProducts(gridWrapper);
      state.visibleItems += STEP;
      applyVisibility(gridWrapper, state.visibleItems);

      btn.disabled = false;
      isPaused = false;
      updateButtonVisibility(gridWrapper, state);
    });

    return btnWrapper;
  }

  function initGrid(gridWrapper) {
    if (!gridsState.has(gridWrapper)) {
      gridsState.set(gridWrapper, {
        visibleItems: STEP,
        btnElement: null,
        waitingForTitles: false
      });
    }

    const state = gridsState.get(gridWrapper);

    if (state.waitingForTitles) return;
    state.waitingForTitles = true;

    waitForTitles(gridWrapper, () => {
      state.waitingForTitles = false;

      hideExcludedProducts(gridWrapper);

      const eligible = getEligibleProducts(gridWrapper);
      if (eligible.length === 0) return;

      applyVisibility(gridWrapper, state.visibleItems);

      // Add the button (or re-add it if the app re-rendered and removed it)
      const buttonMissing = !state.btnElement || !state.btnElement.isConnected;
      if (eligible.length > STEP && buttonMissing) {
        state.btnElement = createLoadMoreButton(gridWrapper, state);
        gridWrapper.after(state.btnElement);
      }

      updateButtonVisibility(gridWrapper, state);
    });
  }

  function initAll() {
    document.querySelectorAll(GRID_SELECTOR).forEach(initGrid);
  }

  // ─── MutationObserver ───────────────────────────────────────────────────────
  let debounceTimer;
  const observer = new MutationObserver(() => {
    if (isPaused) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initAll, 200);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ─── Start ──────────────────────────────────────────────────────────────────
  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }
})();


// add to box button trigger on paroduct card
document.addEventListener('click', function (e) {
  //console.log('Click detected on:', e.target);

  const productCard = e.target.closest('.cyo-product-grid-wapper .productContent-module__card_product__Hh');

  if (productCard) {
   
    const isExcluded = e.target.closest('.cyo-product-grid-wapper .addToBoxButton-module__button_atc__zo') ||
      e.target.closest('.cyo-product-grid-wapper .productContent-module__icon_search_product__Lx') ||
      e.target.closest('.cyo-product-grid-wapper a') || 
      e.target.closest('.cyo-product-grid-wapper button');

    if (isExcluded) {
      return;
    }

    const addToBoxBtn = productCard.querySelector('.cyo-product-grid-wapper .addToBoxButton-module__button_atc_content__wU');

    if (addToBoxBtn) {
      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });

      addToBoxBtn.dispatchEvent(clickEvent);
      //console.log(' Add to Box button clicked with MouseEvent!');
    } else {
      //console.log('❌ Add to Box button NOT found');
    }
  } else {
    //console.log('ℹ️ Click outside product card');
  }
});

document.querySelectorAll('#tb-bulk-radio input[type="radio"]').forEach(radio => {
  radio.addEventListener('mousedown', function(e) {
    if (this.checked) {
      e.preventDefault();
    }
  });
});
const nextBtnObserver = new MutationObserver(() => {
  const btn = document.querySelector('.review-summery .BOX_REVIEW_PAGE_CREATE_NEW_BOX_BUTTON_TS span');
  if (btn && btn.textContent === 'Create New Box') {
    btn.textContent = 'Create New';
  }
});

nextBtnObserver.observe(document.body, { childList: true, subtree: true });

//bulk app
(function () {
  function injectDownloadButton() {
    const multiAddress = document.getElementById('tb-bulk-multi-address');
    if (!multiAddress) return;

    // Avoid duplicate injection
    if (multiAddress.querySelector('.multi-address-downlaod-wapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'multi-address-downlaod-wapper';

    const link = document.createElement('a');
    link.href = 'https://cdn.shopify.com/s/files/1/0517/2061/8175/files/Hampers_Galore_Corporate_Bulk_Order_Form--2026.xlsx?v=1788434334';
    link.className = 'cgb-download-template-btn';
    link.setAttribute('download', '');
    link.textContent = 'Download bulk Address form (Excel Template)';

    wrapper.appendChild(link);
    multiAddress.insertBefore(wrapper, multiAddress.firstChild);
  }

  function init() {
    const multiAddress = document.getElementById('tb-bulk-multi-address');
    
    if (!multiAddress) return false;

    // Inject download button
    injectDownloadButton();

    return true;
  }

  const observer = new MutationObserver(function () {
    init(); // Keep observing for SPA navigation
  });

  observer.observe(document.body, { childList: true, subtree: true });

  init(); // Initial attempt

})();

// next button configaration
(function() {
  function init() {
    //console.log("Initialization running!");
    
    // ─── Hide CYO Products on Page Load ───────────────────────────────────────
    function hideCYOProducts() {
      const productCards = document.querySelectorAll('.gba-bulk-accodian .productContent-module__card_product__Hh[data-product-id]');
      productCards.forEach(function (card) {
        const titleEl = card.querySelector('.productContent-module__product_information_title__em');
        if (titleEl) {
          const titleText = titleEl.textContent.trim().toLowerCase();
          if (
            titleText.includes('cyo') ||
            titleText.includes('voucher') ||
            titleText.includes('eGift Card') ||
            titleText.includes('create your own')
          ) {
            card.style.display = 'none';
          }
        }
      });
    }

    // Run CYO hide immediately
    hideCYOProducts();

    // ─── MutationObserver for CYO + Button Moving ─────────────────────────────
    const observer = new MutationObserver(function (mutations, obs) {
      hideCYOProducts();

      // ─── Move Next Buttons ───────────────────────────────────────────────────
      const allButtons = document.querySelectorAll('.style1Header-module__item__0i');

      const buttonMap = [
        { text: 'Step 2 –  Branding Options',         nextLabel: 'Next : Branding Options',         target: '#gba-accdian-item-wapper-2' },
        { text: 'Step 2.5 –  Add a Photo & Message',     nextLabel: 'Next : Add a Photo & Message',     target: '#gba-accdian-item-wapper-3' },
        { text: 'Step 3 – Add Greeting Card Message', nextLabel: 'Next : Add Greeting Card Message', target: '#gba-accdian-item-wapper-4' },
        { text: 'Step 4 – Add Recipient Adresses',    nextLabel: 'Next : Add Recipient Adresses',    target: '#gba-accdian-item-wapper-5' },
      ];

      buttonMap.forEach(function ({ text, nextLabel, target }) {
        // console.log("Processing button:", text);
        const button = Array.from(allButtons).find(btn =>
          btn.textContent.trim().includes(text)
        );
        const wrapper = document.querySelector(target);

        if (button && wrapper && !button.classList.contains('gba-moved-next-btn')) {
          button.classList.add('gba-moved-next-btn');

          const labelEl = button.querySelector('div');
          if (labelEl) labelEl.textContent = nextLabel;

          button.addEventListener('click', function () {
            setTimeout(function () {
              const scrollEl = document.querySelector(target);
              if (scrollEl) {
                const top = scrollEl.getBoundingClientRect().top + window.scrollY - 130;
                window.scrollTo({ top, behavior: 'smooth' });
              }
            }, 300);
          });

          const btnWrapper = document.createElement('div');
          btnWrapper.classList.add('gba-moved-next-btn-wapper');
          btnWrapper.appendChild(button.parentNode.removeChild(button));
          wrapper.appendChild(btnWrapper);
        }
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Run immediately if DOM is already ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// review page
(function () {
    // Function to check and toggle body class based on review header
    function toggleReviewState() {
        const reviewHeader = document.getElementById('Review-bulk-order-header');
        
        if (reviewHeader) {
            // Second step - add body class
            document.body.classList.add('review-summery');
        } else {
            // First step - remove body class
            document.body.classList.remove('review-summery');
        }
    }

    // Run on page load
    toggleReviewState();

    // Observe for dynamic changes (step transitions)
    const observer = new MutationObserver(toggleReviewState);
    observer.observe(document.body, { childList: true, subtree: true });
})();



//cyo bundle creator easify app js - end


/**
 * ============================================================================
 * MULTI-RECIPIENT ADD-ON  —  for Easify Box Bundle Builder (BYOB)
 * ============================================================================
*/

(function () {
  "use strict";

  // ---------------------------------------------------------------------
  // CONFIG
  // ---------------------------------------------------------------------
  var CONFIG = {
    STORAGE_FIELD_LABEL: "Recipients", // the single native Text Area field that stores everyone
    ADD_BUTTON_TEXT: "+ Add Recipients Manually",
    COUNTRY_NAME: "Australia",
    COUNTRY_DIAL: "+61",
    BRAND_ACCENT: "#b8873f",
    SESSION_STORAGE_KEY: "erw_recipients_v1", // resilience if Box Builder re-renders the step
    ADDRESS_AUTOCOMPLETE: {
      endpoint: "https://photon.komoot.io/api/",
      minChars: 3,
      debounceMs: 300,
      limit: 6
    }
  };

  // Australia-only address metadata (postcode format + known states).
  var AU_META = {
    postcodePattern: /^\d{4}$/,
    postcodeHint: "4 digits, e.g. 2026",
    states: [
      "Australian Capital Territory", "New South Wales", "Northern Territory",
      "Queensland", "South Australia", "Tasmania", "Victoria", "Western Australia"
    ]
  };

  // Soft check only: rough postcode ranges per state, used for a
  // non-blocking "double check this" warning — never blocks Save, since
  // real edge cases exist (PO boxes, redirection postcodes).
  var AU_POSTCODE_RANGES = {
    "Australian Capital Territory": [[200, 299], [2600, 2618], [2900, 2920]],
    "New South Wales": [[1000, 1999], [2000, 2599], [2619, 2899], [2921, 2999]],
    "Victoria": [[3000, 3999], [8000, 8999]],
    "Queensland": [[4000, 4999], [9000, 9999]],
    "South Australia": [[5000, 5999]],
    "Western Australia": [[6000, 6999]],
    "Tasmania": [[7000, 7999]],
    "Northern Territory": [[800, 999]]
  };

  // ---------------------------------------------------------------------
  // STATE
  // ---------------------------------------------------------------------
  var recipients = []; // array of recipient objects, in display order — the
                        // single source of truth; survives even when the
                        // host app wipes our injected UI on a re-render
  var editingIndex = null; // index into `recipients` while editing, else null
  var widgetInjected = false;
  var widgetRoot = null;
  var hiddenFieldRef = null; // the exact field element we last hid/attached after

  // ---------------------------------------------------------------------
  // FIELD-FINDING (the part most likely to need tweaking per store)
  // ---------------------------------------------------------------------

  function findFieldByLabel(labelText) {
    var candidates = document.querySelectorAll(
      "label, .field-label, .option-label, span, div, p, legend"
    );
    var target = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent.trim() === labelText) {
        target = el;
        break;
      }
    }
    if (!target) return null;

    var node = target;
    for (var depth = 0; depth < 6 && node; depth++) {
      if (node.querySelector) {
        var field = node.querySelector('textarea, input[type="text"]');
        if (field) return field;
      }
      node = node.parentElement;
    }
    return null;
  }

  function climbToContainer(el, depth) {
    var node = el;
    for (var i = 0; i < depth && node.parentElement; i++) {
      node = node.parentElement;
    }
    return node;
  }

  function setNativeValue(el, value) {
    if (!el) return;
    var proto =
      el.tagName === "TEXTAREA"
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(proto, "value");
    if (descriptor && descriptor.set) {
      descriptor.set.call(el, value);
    } else {
      el.value = value;
    }
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // ---------------------------------------------------------------------
  // FORMATTING + SYNCING recipient data into Easify's native field
  //
  // Design goals for this format, given it all lives in ONE field:
  //   - a numbered heading per recipient ("1. Jane Smith") so entries are
  //     easy to tell apart at a glance
  //   - short "- Label: value" lines per detail, only when that detail was
  //     actually filled in (no clutter from empty optional fields)
  //   - a plain-hyphen divider line between recipients (never a fancy
  //     unicode character — stays legible in every font/rendering context)
  //   - a leading count line so staff instantly know how many to expect
  // ---------------------------------------------------------------------

  var DIVIDER = "------------------------------";

  function formatRecipientBlock(r, index) {
    var lines = [];
    lines.push(index + ". " + (r.firstName || "") + " " + (r.lastName || ""));
    if (r.email) lines.push("- Email: " + r.email);
    if (r.phone) lines.push("- Phone: " + (r.phoneCode ? r.phoneCode + " " : "") + r.phone);
 
    var addressParts = [];
    if (r.addressLine1) addressParts.push(r.addressLine1);
    if (r.apartment) addressParts.push(r.apartment);
    if (r.buildingName) addressParts.push(r.buildingName);
    var cityLine = [r.suburb, r.state, r.postcode].filter(Boolean).join(" ");
    if (cityLine) addressParts.push(cityLine);
    addressParts.push(CONFIG.COUNTRY_NAME);
    lines.push("- Address: " + addressParts.join(", "));
 
    if (r.deliveryInstructions) lines.push("- Delivery notes: " + r.deliveryInstructions);
    if (r.giftNote) lines.push("- Gift note: " + r.giftNote);
 
    return lines.join("\n");
  }
 
  function buildCombinedText() {
    if (!recipients.length) return "";
    var header = "Total recipients: " + recipients.length;
    var blocks = recipients.map(function (r, i) {
      return formatRecipientBlock(r, i + 1);
    });
    return header + "\n\n" + blocks.join("\n\n" + DIVIDER + "\n\n");
  }
 
  /**
   * Finds whatever storefront element is currently rendering our field's
   * value (the "Review your box" summary step) and forces it to respect
   * embedded line breaks. We locate it by its literal content — the
   * "Total recipients:" string we write ourselves — rather than guessing
   * a CSS class, so this keeps working even if Easify changes their
   * markup. Safe to call repeatedly; it's a no-op once already applied.
   */
  function fixReviewStepLineBreaks() {
    if (!recipients.length) return;
    var candidates = document.querySelectorAll("div, span, p, dd, li, td");
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent.trim().indexOf("Total recipients:") === 0) {
        el.style.whiteSpace = "pre-line";
        if (el.parentElement) el.parentElement.style.whiteSpace = "pre-line";
      }
    }
  }
 
  function syncAllRecipientsToFields() {
    var storageField = findFieldByLabel(CONFIG.STORAGE_FIELD_LABEL);
    if (storageField) setNativeValue(storageField, buildCombinedText());
 
    try {
      sessionStorage.setItem(CONFIG.SESSION_STORAGE_KEY, JSON.stringify(recipients));
    } catch (e) {
      /* sessionStorage unavailable — non-fatal, in-memory state still works */
    }
  }
 
  function rehydrateFromSessionStorage() {
    try {
      var raw = sessionStorage.getItem(CONFIG.SESSION_STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) recipients = parsed;
      }
    } catch (e) {
      /* ignore corrupt/missing data */
    }
  }

  // ---------------------------------------------------------------------
  // ADDRESS VALIDATION HELPERS
  // ---------------------------------------------------------------------

  function isPostcodeValid(postcode) {
    return AU_META.postcodePattern.test((postcode || "").trim());
  }

  function checkAuPostcodeStateMismatch(postcode, state) {
    if (!postcode || !state) return null;
    var ranges = AU_POSTCODE_RANGES[state];
    if (!ranges) return null; // unrecognised state string — skip, don't block
    var num = parseInt(postcode, 10);
    if (isNaN(num)) return null;
    var withinOwnState = ranges.some(function (r) { return num >= r[0] && num <= r[1]; });
    if (withinOwnState) return null;
    return "This postcode doesn't look like it belongs to " + state + " — double-check before saving.";
  }

  // ---------------------------------------------------------------------
  // ADDRESS AUTOCOMPLETE (Photon — free, no API key)
  // ---------------------------------------------------------------------

  function formatSuggestionLabel(props) {
    var streetPart = [props.housenumber, props.street || props.name].filter(Boolean).join(" ");
    var cityPart = props.city || props.town || props.village || props.county || "";
    var regionLine = [cityPart, props.state, props.postcode].filter(Boolean).join(" ");
    return [streetPart, regionLine, props.country].filter(Boolean).join(", ");
  }

  function suggestionToRecipientFields(props) {
    return {
      addressLine1: [props.housenumber, props.street || props.name].filter(Boolean).join(" "),
      suburb: props.city || props.town || props.village || props.county || "",
      state: props.state || "",
      postcode: props.postcode || ""
    };
  }

  /**
   * SWAP POINT: to use a different provider later, replace the body of
   * this function. It must call onResults(arrayOfFeatureLikeObjects) where
   * each item has a `.properties` object shaped like Photon's
   * (housenumber, street, city, state, postcode, country, name).
   */
  function fetchAddressSuggestions(query, signal, onResults, onError) {
    var biasedQuery = query + ", " + CONFIG.COUNTRY_NAME;
    var url =
      CONFIG.ADDRESS_AUTOCOMPLETE.endpoint +
      "?q=" + encodeURIComponent(biasedQuery) +
      "&limit=" + CONFIG.ADDRESS_AUTOCOMPLETE.limit +
      "&lang=en";
    fetch(url, { signal: signal })
      .then(function (res) {
        if (!res.ok) throw new Error("Address lookup failed");
        return res.json();
      })
      .then(function (data) {
        onResults((data && data.features) || []);
      })
      .catch(function (err) {
        if (err.name !== "AbortError") onError(err);
      });
  }

  // ---------------------------------------------------------------------
  // STYLES
  // ---------------------------------------------------------------------
  function injectStyles() {
    var css =
      ".erw-hidden-field{display:none !important;}" +
      ".erw-wrap{font-family:inherit;margin:12px 0;}" +
      ".erw-add-btn{display:inline-flex;align-items:center;gap:6px;padding:10px 16px;" +
      "border:1px solid #d0d0d0;border-radius:8px;background:#fff;cursor:pointer;font-size:14px;font-weight:600;}" +
      ".erw-add-btn:hover{border-color:#999;}" +
      ".erw-list{margin-top:14px;display:flex;flex-direction:column;gap:8px;}" +
      ".erw-card{border:1px solid #e5e5e5;border-radius:8px;padding:10px 12px;display:flex;justify-content:space-between;align-items:flex-start;gap:10px;background:#fafafa;}" +
      ".erw-card-index{display:inline-block;min-width:20px;height:20px;border-radius:50%;background:" + CONFIG.BRAND_ACCENT + ";color:#fff;" +
      "font-size:11px;font-weight:700;text-align:center;line-height:20px;margin-right:8px;}" +
      ".erw-card-name{font-weight:600;font-size:14px;display:inline-flex;align-items:center;}" +
      ".erw-card-sub{font-size:12px;color:#666;margin-top:4px;line-height:1.5;padding-left:28px;}" +
      ".erw-card-actions{display:flex;gap:8px;flex-shrink:0;}" +
      ".erw-icon-btn{background:none;border:none;cursor:pointer;font-size:13px;color:#555;text-decoration:underline;padding:0;}" +
      ".erw-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:99998;display:flex;align-items:flex-start;justify-content:center;overflow:auto;padding:32px 16px;}" +
      ".erw-modal{background:#fff;border-radius:14px;max-width:640px;width:100%;padding:28px 28px 20px;position:relative;z-index:99999;}" +
      ".erw-modal h2{margin:0 0 20px;font-size:20px;}" +
      ".erw-close{position:absolute;top:16px;right:16px;background:none;border:none;font-size:18px;cursor:pointer;color:#666;}" +
      ".erw-section-title{font-weight:700;font-size:14px;margin:18px 0 10px;}" +
      ".erw-row{display:flex;gap:10px;margin-bottom:10px;}" +
      ".erw-row > div{flex:1;min-width:0;}" +
      ".erw-field{position:relative;}" +
      ".erw-field label{display:block;font-size:12px;color:#555;margin-bottom:4px;}" +
      ".erw-field input, .erw-field select, .erw-field textarea{width:100%;box-sizing:border-box;padding:10px 12px;" +
      "border:1px solid #d5d5d5;border-radius:8px;font-size:14px;font-family:inherit;}" +
      ".erw-field textarea{resize:vertical;min-height:70px;}" +
      ".erw-field-note{font-size:11px;color:#999;margin-top:4px;}" +
      ".erw-field-error-text{font-size:11px;color:#c0392b;margin-top:4px;display:none;}" +
      ".erw-phone-row{display:flex;gap:8px;}" +
      ".erw-phone-row select{max-width:88px;}" +
      ".erw-chips{display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;}" +
      ".erw-chip{border:1px solid #d5d5d5;border-radius:999px;padding:6px 12px;font-size:12px;background:#fff;cursor:pointer;}" +
      ".erw-chip:hover{border-color:#999;}" +
      ".erw-hint{font-size:12px;color:#888;margin:2px 0 10px;}" +
      ".erw-footer{display:flex;justify-content:flex-end;gap:10px;margin-top:18px;padding-top:16px;border-top:1px solid #eee;}" +
      ".erw-btn-secondary{padding:11px 20px;border-radius:999px;border:1px solid #d5d5d5;background:#fff;cursor:pointer;font-weight:600;font-size:14px;}" +
      ".erw-btn-primary{padding:11px 20px;border-radius:999px;border:none;cursor:pointer;font-weight:700;font-size:14px;" +
      "background:" + CONFIG.BRAND_ACCENT + ";color:#fff;display:inline-flex;align-items:center;gap:6px;}" +
      ".erw-btn-primary:hover{opacity:0.92;}" +
      ".erw-error{color:#c0392b;font-size:12px;margin-top:8px;}" +
      ".erw-warning{color:#8a6116;background:#fff7e6;border:1px solid #f0d68a;border-radius:6px;padding:8px 10px;font-size:12px;margin-top:10px;display:none;}" +
      ".erw-count{font-size:13px;color:#666;margin-left:10px;}" +
      ".erw-empty{font-size:13px;color:#888;margin-top:10px;}" +
      ".erw-suggest-list{position:absolute;top:100%;left:0;right:0;background:#fff;border:1px solid #d5d5d5;" +
      "border-radius:8px;margin-top:4px;max-height:220px;overflow-y:auto;z-index:5;box-shadow:0 4px 14px rgba(0,0,0,0.10);}" +
      ".erw-suggest-item{padding:9px 12px;font-size:13px;cursor:pointer;border-bottom:1px solid #f0f0f0;}" +
      ".erw-suggest-item:last-child{border-bottom:none;}" +
      ".erw-suggest-item:hover, .erw-suggest-item.erw-active{background:#faf3e6;}" +
      ".erw-suggest-status{padding:9px 12px;font-size:12px;color:#888;}";

    var styleTag = document.createElement("style");
    styleTag.setAttribute("data-erw", "true");
    styleTag.textContent = css;
    document.head.appendChild(styleTag);
  }

  // ---------------------------------------------------------------------
  // MODAL
  // ---------------------------------------------------------------------

  function emptyRecipient() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phoneCode: CONFIG.COUNTRY_DIAL,
      phone: "",
      addressLine1: "",
      apartment: "",
      buildingName: "",
      suburb: "",
      state: "",
      postcode: "",
      deliveryInstructions: "",
      giftNote: ""
    };
  }

  function fieldHtml(id, labelText, extraAttrs) {
    return (
      '<div class="erw-field">' +
      '<label for="' + id + '">' + labelText + "</label>" +
      '<input type="text" id="' + id + '" ' + (extraAttrs || "") + ">" +
      "</div>"
    );
  }

  function openModal(index) {
    editingIndex = typeof index === "number" ? index : null;
    var data = editingIndex !== null ? recipients[editingIndex] : emptyRecipient();

    var overlay = document.createElement("div");
    overlay.className = "erw-overlay";
    overlay.setAttribute("data-erw-overlay", "true");

    overlay.innerHTML =
      '<div class="erw-modal" role="dialog" aria-modal="true">' +
      '<button type="button" class="erw-close" aria-label="Close">&#10005;</button>' +
      "<h2>" + (editingIndex !== null ? "Edit recipient" : "Add Recipient") + "</h2>" +
      '<div class="erw-section-title">Contact details</div>' +
      '<div class="erw-row">' +
      fieldHtml("erw-firstName", "First name") +
      fieldHtml("erw-lastName", "Last name") +
      "</div>" +
      '<div class="erw-row">' +
      '<div class="erw-field"><label for="erw-email">Email</label><input type="email" id="erw-email"></div>' +
      '<div class="erw-field"><label>Mobile phone</label>' +
      '<div class="erw-phone-row">' +
      '<select id="erw-phoneCode"><option value="' + CONFIG.COUNTRY_DIAL + '" selected>' + CONFIG.COUNTRY_DIAL + "</option></select>" +
      '<input type="tel" id="erw-phone" placeholder="Mobile phone">' +
      "</div></div>" +
      "</div>" +

      '<div class="erw-section-title">Address</div>' +

      '<div class="erw-field" style="margin-bottom:2px;"><label for="erw-addressLine1">Address</label>' +
      '<input type="text" id="erw-addressLine1" placeholder="Start typing your street address…" autocomplete="off">' +
      '<div class="erw-suggest-list" id="erw-suggest-list" style="display:none;"></div>' +
      "</div>" +
      '<div class="erw-field-note" style="margin-bottom:10px;">Please add address correctly (We do not deliver to PO Boxes)</div>' +

      '<div class="erw-field" style="margin-bottom:10px;"><label for="erw-apartment">Apartment, suite, unit </label>' +
      '<input type="text" id="erw-apartment"></div>' +
      '<div class="erw-field" style="margin-bottom:10px;"><label for="erw-buildingName">Building name (optional)</label>' +
      '<input type="text" id="erw-buildingName"></div>' +
      '<div class="erw-row">' +
      fieldHtml("erw-suburb", "Suburb") +
      fieldHtml("erw-state", "State", 'list="erw-state-datalist"') +
      '<div class="erw-field">' +
      '<label for="erw-postcode">Postcode</label>' +
      '<input type="text" id="erw-postcode">' +
      '<div class="erw-field-error-text" data-erw-postcode-error></div>' +
      "</div>" +
      "</div>" +
      '<datalist id="erw-state-datalist">' +
      AU_META.states.map(function (s) { return '<option value="' + s + '">'; }).join("") +
      "</datalist>" +

      '<div class="erw-warning" data-erw-au-warning></div>' +

      '<div class="erw-section-title">Delivery instructions (optional)</div>' +
      '<textarea id="erw-deliveryInstructions" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d5d5d5;border-radius:8px;min-height:70px;font-family:inherit;font-size:14px;"></textarea>' +

      '<div class="erw-section-title">Change gift note</div>' +
      '<div class="erw-hint">This will override your default order gift note for this recipient.</div>' +
      '<textarea id="erw-giftNote" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #d5d5d5;border-radius:8px;min-height:90px;font-family:inherit;font-size:14px;"></textarea>' +
      '<div class="erw-chips">' +
      '<button type="button" class="erw-chip" data-insert="full">+ Full name</button>' +
      '<button type="button" class="erw-chip" data-insert="first">+ First name</button>' +
      '<button type="button" class="erw-chip" data-insert="last">+ Last name</button>' +
      "</div>" +

      '<div class="erw-error" data-erw-error style="display:none;"></div>' +

      '<div class="erw-footer">' +
      '<button type="button" class="erw-btn-secondary" data-erw-save>Save</button>' +
      (editingIndex === null
        ? '<button type="button" class="erw-btn-primary" data-erw-save-add>+ Save and add another</button>'
        : "") +
      "</div>" +
      "</div>";

    document.body.appendChild(overlay);

    Object.keys(data).forEach(function (key) {
      var el = overlay.querySelector("#erw-" + key);
      if (el) el.value = data[key];
    });

    // ---- element refs used across the handlers below ----
    var addressInput = overlay.querySelector("#erw-addressLine1");
    var suggestList = overlay.querySelector("#erw-suggest-list");
    var suburbField = overlay.querySelector("#erw-suburb");
    var stateField = overlay.querySelector("#erw-state");
    var postcodeField = overlay.querySelector("#erw-postcode");
    var postcodeErrorEl = overlay.querySelector("[data-erw-postcode-error]");
    var auWarningEl = overlay.querySelector("[data-erw-au-warning]");

    function closeModal() {
      overlay.remove();
    }

    overlay.querySelector(".erw-close").addEventListener("click", closeModal);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeModal();
    });

    // ---- Postcode format + AU state/postcode mismatch validation (live) ----
    function runSoftValidation() {
      var pc = postcodeField.value.trim();

      if (pc && !isPostcodeValid(pc)) {
        postcodeErrorEl.textContent = "Doesn't look like a valid postcode (" + AU_META.postcodeHint + ").";
        postcodeErrorEl.style.display = "block";
      } else {
        postcodeErrorEl.style.display = "none";
      }

      var mismatch = checkAuPostcodeStateMismatch(pc, stateField.value.trim());
      if (mismatch) {
        auWarningEl.textContent = mismatch;
        auWarningEl.style.display = "block";
      } else {
        auWarningEl.style.display = "none";
      }
    }
    postcodeField.addEventListener("blur", runSoftValidation);
    stateField.addEventListener("blur", runSoftValidation);

    // ---- Address autocomplete ----
    var debounceTimer = null;
    var abortController = null;
    var activeIndex = -1;
    var currentFeatures = [];

    function hideSuggestions() {
      suggestList.style.display = "none";
      suggestList.innerHTML = "";
      activeIndex = -1;
    }

    function showStatus(text) {
      suggestList.innerHTML = '<div class="erw-suggest-status">' + text + "</div>";
      suggestList.style.display = "block";
    }

    function renderSuggestions(features) {
      currentFeatures = features;
      activeIndex = -1;
      if (!features.length) {
        showStatus("No matches — you can still enter the address manually.");
        return;
      }
      suggestList.innerHTML = "";
      features.forEach(function (feature, i) {
        var item = document.createElement("div");
        item.className = "erw-suggest-item";
        item.setAttribute("data-index", i);
        item.textContent = formatSuggestionLabel(feature.properties || {});
        item.addEventListener("mousedown", function (e) {
          // mousedown (not click) so it fires before the input's blur hides the list
          e.preventDefault();
          selectSuggestion(feature);
        });
        suggestList.appendChild(item);
      });
      suggestList.style.display = "block";
    }

    function selectSuggestion(feature) {
      var filled = suggestionToRecipientFields(feature.properties || {});
      if (filled.addressLine1) addressInput.value = filled.addressLine1;
      if (filled.suburb) suburbField.value = filled.suburb;
      if (filled.postcode) postcodeField.value = filled.postcode;
      if (filled.state) stateField.value = filled.state;
      hideSuggestions();
      runSoftValidation();
    }

    addressInput.addEventListener("input", function () {
      var query = addressInput.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < CONFIG.ADDRESS_AUTOCOMPLETE.minChars) {
        hideSuggestions();
        return;
      }
      debounceTimer = setTimeout(function () {
        if (abortController) abortController.abort();
        abortController = new AbortController();
        showStatus("Searching…");
        fetchAddressSuggestions(
          query,
          abortController.signal,
          renderSuggestions,
          function () {
            showStatus("Couldn't reach address lookup — you can still type the address manually.");
          }
        );
      }, CONFIG.ADDRESS_AUTOCOMPLETE.debounceMs);
    });

    addressInput.addEventListener("keydown", function (e) {
      var items = suggestList.querySelectorAll(".erw-suggest-item");
      if (!items.length || suggestList.style.display === "none") return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        items.forEach(function (el, i) { el.classList.toggle("erw-active", i === activeIndex); });
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        items.forEach(function (el, i) { el.classList.toggle("erw-active", i === activeIndex); });
      } else if (e.key === "Enter") {
        if (activeIndex >= 0 && currentFeatures[activeIndex]) {
          e.preventDefault();
          selectSuggestion(currentFeatures[activeIndex]);
        }
      } else if (e.key === "Escape") {
        hideSuggestions();
      }
    });

    addressInput.addEventListener("blur", function () {
      // slight delay so a mousedown-selection on a suggestion still registers
      setTimeout(hideSuggestions, 150);
    });

    // ---- Gift note chips (uses the First/Last name typed in THIS modal) ----
    overlay.querySelectorAll(".erw-chip").forEach(function (chip) {
      chip.addEventListener("click", function () {
        var first = overlay.querySelector("#erw-firstName").value.trim();
        var last = overlay.querySelector("#erw-lastName").value.trim();
        var insertType = chip.getAttribute("data-insert");
        var value =
          insertType === "full"
            ? (first + " " + last).trim() || "[Recipient name]"
            : insertType === "first"
            ? first || "[First name]"
            : last || "[Last name]";
        var textarea = overlay.querySelector("#erw-giftNote");
        var start = textarea.selectionStart || textarea.value.length;
        var end = textarea.selectionEnd || textarea.value.length;
        textarea.value = textarea.value.slice(0, start) + value + textarea.value.slice(end);
        textarea.focus();
        var pos = start + value.length;
        textarea.setSelectionRange(pos, pos);
      });
    });

    function collectFormData() {
      var out = {};
      ["firstName", "lastName", "email", "phoneCode", "phone",
        "addressLine1", "apartment", "buildingName", "suburb", "state",
        "postcode", "deliveryInstructions", "giftNote"].forEach(function (key) {
        var el = overlay.querySelector("#erw-" + key);
        out[key] = el ? el.value.trim() : "";
      });
      return out;
    }

    function validate(data) {
      var required = ["firstName", "lastName", "addressLine1", "suburb", "state", "postcode"];
      var missing = required.filter(function (key) { return !data[key]; });
      var formatErrors = [];
      if (!missing.length && !isPostcodeValid(data.postcode)) {
        formatErrors.push("Postcode doesn't look right (" + AU_META.postcodeHint + ").");
      }
      return { missing: missing, formatErrors: formatErrors };
    }

    function showError(msg) {
      var errorEl = overlay.querySelector("[data-erw-error]");
      errorEl.textContent = msg;
      errorEl.style.display = "block";
    }

    function handleSave(andAddAnother) {
      var data = collectFormData();
      var result = validate(data);
      if (result.missing.length) {
        showError("Please fill in: " + result.missing.join(", "));
        return;
      }
      if (result.formatErrors.length) {
        showError(result.formatErrors.join(" "));
        return;
      }
      if (editingIndex !== null) {
        recipients[editingIndex] = data;
      } else {
        recipients.push(data);
      }
      syncAllRecipientsToFields();
      renderRecipientList();
      closeModal();
      if (andAddAnother) openModal();
    }

    overlay.querySelector("[data-erw-save]").addEventListener("click", function () {
      handleSave(false);
    });
    var saveAddBtn = overlay.querySelector("[data-erw-save-add]");
    if (saveAddBtn) {
      saveAddBtn.addEventListener("click", function () {
        handleSave(true);
      });
    }

    // Run once on open in case we're editing a recipient with existing data
    runSoftValidation();
    overlay.querySelector("#erw-firstName").focus();
  }

  // ---------------------------------------------------------------------
  // RECIPIENT LIST UI
  // ---------------------------------------------------------------------

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  function renderRecipientList() {
    if (!widgetRoot) return;
    var listEl = widgetRoot.querySelector(".erw-list");
    var countEl = widgetRoot.querySelector(".erw-count");
    countEl.textContent = recipients.length
      ? recipients.length + (recipients.length === 1 ? " recipient added" : " recipients added")
      : "";

    listEl.innerHTML = "";

    if (!recipients.length) {
      var empty = document.createElement("div");
      empty.className = "erw-empty";
      empty.textContent = "No recipients added yet.";
      listEl.appendChild(empty);
      return;
    }

    recipients.forEach(function (r, i) {
      var card = document.createElement("div");
      card.className = "erw-card";
      var addressBits = [r.suburb, r.state, r.postcode].filter(Boolean).join(" ");
      var contactBits = [r.email, r.phone ? (r.phoneCode + " " + r.phone) : ""].filter(Boolean).join(" · ");
      card.innerHTML =
        '<div>' +
        '<div class="erw-card-name"><span class="erw-card-index">' + (i + 1) + '</span>' +
        escapeHtml(r.firstName + " " + r.lastName) +
        "</div>" +
        '<div class="erw-card-sub">' +
        escapeHtml([r.addressLine1, addressBits].filter(Boolean).join(", ")) +
        (contactBits ? "<br>" + escapeHtml(contactBits) : "") +
        "</div></div>" +
        '<div class="erw-card-actions">' +
        '<button type="button" class="erw-icon-btn" data-edit>Edit</button>' +
        '<button type="button" class="erw-icon-btn" data-remove>Remove</button>' +
        "</div>";
      card.querySelector("[data-edit]").addEventListener("click", function () {
        openModal(i);
      });
      card.querySelector("[data-remove]").addEventListener("click", function () {
        recipients.splice(i, 1);
        syncAllRecipientsToFields();
        renderRecipientList();
      });
      listEl.appendChild(card);
    });
  }

  // ---------------------------------------------------------------------
  // WIDGET INJECTION
  // ---------------------------------------------------------------------

  function hideFieldContainer(fieldEl) {
    var node = climbToContainer(fieldEl, 3);
    node.classList.add("erw-hidden-field");
    return node;
  }

  /**
   * Removes every widget instance currently in the page. Called at the
   * start of every injectWidget() run (see WIDGET CLEANUP note above) so
   * toggling the "Single address"/"Multiple addresses" radio back and
   * forth can never leave stray, orphaned copies behind.
   */
  function removeAllWidgetInstances() {
    document.querySelectorAll(".erw-wrap").forEach(function (el) {
      el.remove();
    });
  }

  /**
   * Attempts to inject the button+list next to the live "Recipients"
   * field. Returns true on success. Safe to call repeatedly — e.g. after
   * the host app has re-rendered that section and wiped our previous
   * injection, or after the conditional radio button has shown/hidden the
   * field, this builds a fresh one against whatever field element exists
   * right now, after first clearing away any stale copy.
   */
  function injectWidget() {
    var storageField = findFieldByLabel(CONFIG.STORAGE_FIELD_LABEL);

    if (!storageField) {
      // Field isn't currently rendered — e.g. "Single address" is
      // selected right now. Clean up any leftover widget from a previous
      // selection and reset our state; there's nothing to attach to.
      removeAllWidgetInstances();
      widgetInjected = false;
      widgetRoot = null;
      hiddenFieldRef = null;
      return false;
    }

    // Always start from a clean slate — guarantees exactly one widget on
    // the page no matter how many times this has run before.
    removeAllWidgetInstances();

    var container = hideFieldContainer(storageField);
    hiddenFieldRef = storageField;

    widgetRoot = document.createElement("div");
    widgetRoot.className = "erw-wrap";
    widgetRoot.innerHTML =
      '<button type="button" class="erw-add-btn">' + CONFIG.ADD_BUTTON_TEXT + "</button>" +
      '<span class="erw-count"></span>' +
      '<div class="erw-list"></div>';

    container.insertAdjacentElement("afterend", widgetRoot);
    widgetRoot.querySelector(".erw-add-btn").addEventListener("click", function () {
      openModal();
    });

    renderRecipientList();
    widgetInjected = true;
    return true;
  }

  /**
   * True only if everything we injected is still actually standing in the
   * live DOM AND still attached next to the field that's currently
   * rendered (not a stale reference to a field the host app has since
   * replaced). If the host app re-renders that section — which wipes any
   * DOM it doesn't recognise, including our button/list — this goes
   * false, and ensureWidgetHealthy() below re-injects and re-syncs our
   * recipients (still safely held in memory) right back in.
   */
  function isWidgetHealthy() {
    if (!widgetInjected) return false;
    if (!widgetRoot || !document.body.contains(widgetRoot)) return false;
    var currentField = findFieldByLabel(CONFIG.STORAGE_FIELD_LABEL);
    if (!currentField || currentField !== hiddenFieldRef) return false;
    return true;
  }

  function ensureWidgetHealthy() {
    if (isWidgetHealthy()) return;
    widgetInjected = false;
    if (injectWidget()) {
      syncAllRecipientsToFields(); // our data was never lost — push it back into the fresh field
    }
  }


  // ---------------------------------------------------------------------
  // INIT — Box Builder is a single-page app: the field may not exist yet
  // when this script first runs, and later re-renders of that step can
  // silently wipe our injected UI. So this keeps checking for the whole
  // lifetime of the page, not just until the first successful injection.
  // ---------------------------------------------------------------------
  function init() {
    injectStyles();
    rehydrateFromSessionStorage();
 
    setInterval(function () {
      ensureWidgetHealthy();
      fixReviewStepLineBreaks();
    }, 1000);
 
    var observerDebounce = null;
    var observer = new MutationObserver(function () {
      clearTimeout(observerDebounce);
      observerDebounce = setTimeout(function () {
        ensureWidgetHealthy();
        fixReviewStepLineBreaks();
      }, 250);
    });
    observer.observe(document.body, { childList: true, subtree: true });
 
    ensureWidgetHealthy();
  }
 
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
 


/******************************************************************** */